<template>
  <div class="signup-login-wrapper">
    <div class="logo-wrapper">
      <a href="/">
        <GkLogoAnim theme="white" />
      </a>
    </div>
    <div class="signup-login-form-wrap">
      <transition name="fade" appear mode="out-in">
        <LoginForm
          v-if="formType === 'login'"
          :key="mainTransitionKey"
          @authorised="$emit('authorised', false)"
          :remember-email="rememberEmail"
          @remember-email="(email) => { rememberEmail = email }"
          @show-country="formType = 'country'"
        />
        <ForgotPasswordForm
          v-if="formType === 'forgot'"
          :key="mainTransitionKey"
          :remember-email="rememberEmail"
          @remember-email="(email) => { rememberEmail = email }"
        />
        <ResetPasswordForm
          v-if="formType === 'reset'"
          :key="mainTransitionKey"
          :remember-email="rememberEmail"
          @remember-email="(email) => { rememberEmail = email }"
        />
        <SignupCountryForm
          v-if="formType === 'country'"
          :key="mainTransitionKey"
          @authorised="$emit('authorised', false)"
        />
      </transition>
    </div>
    <transition name="fade-delayed" appear mode="out-in">
      <div v-if="formType === 'login' || formType === 'country'" class="security">
        <div class="secure-online">
          <font-awesome-icon icon="fa-solid fa-shield-check" />
          <div>{{ $gettext('All your data is securely transmitted from you, and securely stored on, our European servers.') }}</div>
        </div>
        <div v-if="formType !== 'country'" class="signup-link-wrap">
          {{ $gettext('Don\'t have an account?') }} <router-link data-analytics-click="signup from login" :to="{ name: 'Signup', query: { ...$route.query } }" class="signup-link text-blue">{{ $gettext('Create one now!') }}</router-link>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

import GkLogoAnim from "@/components/ui/GkLogoAnim"
import GekkoButton from "@/components/GekkoButton"

import LoginForm from '@/components/auth/LoginForm'
import ForgotPasswordForm from '@/components/auth/ForgotPasswordForm'
import ResetPasswordForm from '@/components/auth/ResetPasswordForm'
import SignupCountryForm from '@/components/auth/SignupCountryForm'

export default {
  name: 'Login',
  components: {
    GekkoButton,
    GkLogoAnim,
    LoginForm,
    ForgotPasswordForm,
    ResetPasswordForm,
    SignupCountryForm
  },
  data () {
    return {
      formType: 'login',
      mainTransitionKey: 0,
      rememberEmail: ''
    }
  },
  computed: {
    ...mapGetters({ 
      isAuthenticated: "auth/getAuthenticated",
      isNewAccount: 'signup/getSignupStatus',
      newAccountType: 'signup/getSignupType'
    })
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        switch (to.name) {
          case 'Login':
            this.formType = 'login'
            break;
          case 'ForgotPassword':
            this.formType = 'forgot'
            break;
          case 'ResetPassword':
            this.formType = 'reset'
            break;
        }
        this.mainTransitionKey++
      }
    }
  },
  created () {
    this.setupData()
  },
  mounted () {
    
  },
  methods: {
    setupData () {
      if (this.isAuthenticated) {
        console.log('Login.vue::setupData() -> User is already logged in, redirecting to Dashboard')
        if (this.isNewAccount) {
          if (this.newAccountType === 'accountant') {
            // TODO redirect to accountants portal
            this.$router.push({ name: 'Ledger', query: { welcome: 'yes' }  }).catch(() => {})
          } else {
            // window.location.href = Urls["gekko_dashboard"]() + "?welcome=yes"
            this.$router.push({ name: 'Dashboard', query: { welcome: 'yes', ...this.$route.query }  }).catch(() => {})
          }
        } else {
          // window.location.href = Urls["gekko_dashboard"]()
          this.$router.push({ name: 'Dashboard', query: { ...this.$route.query } }).catch(() => {})
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .signup-login-form-wrap {
    position: relative;
    padding: 1rem;
    padding-top: 1.5rem;
    background: white;
    border-radius: $radiusLg;
    box-shadow: rgba(60, 66, 87, 0.08) 0px 15px 35px 0px, rgba(0, 0, 0, 0.12) 0px 5px 15px 0px;
    width: 100%;
    @media (min-width: 576px) {
      padding: 2rem;
    }
    @media (min-width: 768px) {
      padding: 3rem;
    }
    h2 {
      color: #333;
      margin-bottom: 2rem;
      font-size: 28px;
    }
    p {
      font-size: 1rem;
      color: $colorTextSemi;
      font-family: 'Campton-Book';
    }
    strong {
      font-family: 'Campton-Bold';
    }
    .gk-clear-form {
      label {
        font-family: 'Campton-Book';
        opacity: 1;
      }
      .form-control {
        font-family: 'Campton-Book';
        background-image: none;
        &:focus { box-shadow: none; }
        #placeholder {
        }
      }
    }
    .form-text {
      line-height: 1.3;
      font-size: 14px;
      margin-top: 0.5rem;
      transition: opacity 0.3s ease;
    }
  }
  .signup-login-wrapper {
    display: flex;
    flex-direction: column;
    margin-top: 50px;
    margin-bottom: 50px;
    margin: 0 auto;

    .logo-wrapper {
      padding-bottom: 40px;
      padding-left: 20px;
    }

    .security {
      font-family: 'Campton-Book';
      width: 100%;
			padding: 2rem;
			margin-top: 1rem;
			color: #333 !important;
      h4 {
        font-family: 'Campton-Bold';
      }
			h4, p {
				color: #333 !important;
				font-size: 1rem !important;
			}
			.signup-link-wrap {
				font-size: 1rem;
        // text-align: center;
        font-size: 14px;
        padding-left: 40px;
				.signup-link {
          cursor: pointer;
					width: 100%;
					text-align: center;
					margin-top: 1rem;
					display: inline;
				}
			}
      .secure-online {
        display: flex;
        align-items: center;
        gap: 0.75rem;
				margin-bottom: 1rem;
        > div {
          font-size: 14px;
          line-height: 1.4;
          // opacity: 0.7;
        }
        .svg-inline--fa {
          font-size: 28px;
          opacity: 0.3;
        }
      }
		}
  }
</style>

<style lang="scss" scoped>
  .signup-login-wrapper {
    max-width: 470px;
    width: 470px;
  }
</style>